import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import Details from './onCardNetworksChangeCardDetails.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Group summary='CardNetworks' mdxType="Group">
      <Item title='items' subtitle='CardNetworkDetails[]' mdxType="Item">
        <p>{`An array of the card networks.`}</p>
        <Details mdxType="Details" />
      </Item>
      <Item title='preferred' subtitle='CardNetworkDetails | undefined' mdxType="Item">
        <p>{`The first allowed card network in `}<inlineCode parentName="p">{`items`}</inlineCode>{`.
In case no network is allowed, `}<inlineCode parentName="p">{`undefined`}</inlineCode>{`.`}</p>
        <Details mdxType="Details" />
      </Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      